<template>
  <div class="textlabel" :data-label="Label">
    <div class="input-group" @mouseenter="showPreview = true" @mouseleave="showPreview = false">
      
      <!-- Input de solo lectura para el nombre del archivo -->
      <input
        :id="RefCode"
        type="text"
        class="fileUploader form-control"
        :value="fileName"
        readonly
        aria-describedby="RefCode"
        @click="openFileDialog"
      />

      <!-- Input file real -->
      <input
        type="file"
        ref="fileInput"
        accept="image/png, image/jpeg, image/bmp"
        hidden
        @change="handleFileChange"
      />

      <div class="input-group-append">
        <button type="button" class="btn btn-sm search-attached" @click="openFileDialog">
          <i class="mdi mdi-magnify"></i>
        </button>
      </div>
    </div>

    <!-- Div flotante para mostrar la imagen -->
    <div
      v-if="previewUrl && showPreview"
      class="preview-popup"
    >
      <span class="prevIMGSize bestIMGSize">Best: 650 × 450px</span>
      <img v-if="fileName !== null && fileName !== ''" :src="previewUrl" alt="Preview" />
      <img v-else src="@/assets/images/NoLogo.jpg" data-toggle="modal"/>
      <span class="prevIMGSize yourIMGSize">Yours: 320 × 200px</span>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
export default {
  name: "MdFile",
  props: {
    Label: { type: String, default: "Archivo" },
    Id: { type: String, required: true },
    RefCode: { type: String, required: true },
    File: { type: File, default: null },
    ModelDescription: { type: String, default: "" }
  },
  data() {
    return {
      previewUrl: null,
      showPreview: false,
      fileName: "",
      files:[],
    };
  },
  methods: {
    openFileDialog() {
      this.$refs.fileInput.click();
    },

    SyncFileReader(file) {
      let self = this;
      let ready = false;
      let result = '';
  
      const sleep = function (ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
  
      self.readAsDataURL = async function() {
          while (ready === false) {
            await sleep(100);
          }
          return result;
      }    
  
      const reader = new FileReader();
      reader.onloadend = function(evt) {
          result = evt.target.result;
          ready = true;
      };
      reader.readAsDataURL(file);
    },

    async handleFileChange(event) {
      this.files = [];
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.previewUrl = URL.createObjectURL(file);

          const fileReader = new this.SyncFileReader(file);
          const arrayBuffer = await fileReader.readAsDataURL();
          if(arrayBuffer.indexOf(',') !== -1){
             var b = arrayBuffer.split(',');         
             this.files.push({"fileName":this.fileName,"contents":b[1]});
             this.$emit('ModelFile', this.files);             
            // this.modelCode = this.files[0].length > 0 ? this.files[0].fileName :"";
             //this.FileChanged();         
          }else{
             this.showMessage(this.$tc('Msg.Error'),this.$t('MdNotesInFiles.FileNoBytesMsg'),"error");
          } 

        // Emitimos el archivo al componente padre
       // this.$emit("ModelFile", file);
      }
       event.target.value = ''; 
    }
  },

  created(){
    EventBus.$on("onUpdateFileNameAndUrl", function (data) { 
        this.fileName = data.fileName;
        if(this.fileName !== null && data.fileName !== ""){
          this.previewUrl = data.url;
        }
        
     }.bind(this));
  },

  beforeDestroy() {
    // Liberamos la memoria del objeto temporal
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  }
};
</script>

<style scoped>
/* Div flotante con preview */
.preview-popup {
  bottom: 60px;
  left: 40px;
  position: absolute;
  width: 152px;
  height: 112px;
  background-color: white;
  background-image: linear-gradient(180deg, #262626, #aeaeae);
  box-shadow: 2px 2px 10px #00000099, inset 0 0 10px #00000066 !important;

  border-radius: 6px;
  border: 5px solid #FEFEFE;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  /* Animación suave */
  transition: opacity 1s ease-in-out;
}

/* Imagen dentro del preview */
.preview-popup img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 3px;
  border: 1px dashed #666666;
}

.preview-popup .prevIMGSize{
  position: absolute;
  padding: 0 12px !important;
  font-size: 8px;
  font-weight: bold;
}
.preview-popup .bestIMGSize{
  top: 0;
  background-color: #000000;
  color: #FFF;
  border-radius: 0 0 20px 20px;
  border-bottom: 1px solid #FFF;
  border-right: 1px solid #FFF;
  border-left: 1px solid #FFF;
  box-shadow: 1px 1px 3px #00000066;
}
.preview-popup .yourIMGSize{
  bottom: 0;
  background-color: #c6c6c6CC;
  color: #000000;
  border-radius: 20px 20px 0 0;
  border-top: 1px solid #FFF;
  border-right: 1px solid #FFF;
  border-left: 1px solid #FFF;
  box-shadow: 0 -1px 3px #00000066;
}
/* Importante: aseguramos que el contenedor padre tenga posicionamiento relativo */
.textlabel {
  position: relative;
}
</style>